import React from 'react';
export function Footer() {
  return <footer className="bg-white py-8 border-t border-[#FFB88C]/20" data-id="element-143">
      <div className="max-w-[1200px] mx-auto px-6 text-center" data-id="element-144">
        <p className="text-[#7F8C8D] text-sm mb-4 font-['Inter']" data-id="element-145">
          © {new Date().getFullYear()} Setu. All rights reserved.
        </p>
        <div className="flex justify-center space-x-6 font-['Inter']" data-id="element-146">
          <a href="#" className="text-[#2C3E50] hover:text-[#1B2951] transition-colors" data-id="element-147">
            Privacy Policy
          </a>
          <a href="#" className="text-[#2C3E50] hover:text-[#1B2951] transition-colors" data-id="element-148">
            Terms of Service
          </a>
          <a href="#" className="text-[#2C3E50] hover:text-[#1B2951] transition-colors" data-id="element-149">
            Contact Us
          </a>
        </div>
      </div>
    </footer>;
}